import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../uicomponentcss';
import { Colors } from '../../../utils/resources/colors';
import { Fonts } from '../../../utils/resources/fonts';

export interface TextCSSStyle extends UIComponentCSSStyle
{
    getTextCSSStyle(isFloatingLabel: boolean, isDisabled:boolean): object;
    getErrorCSSStyle(): object;
    getErrorTextDivCSSStyle(): object;
    getErrorTextCSSStyle(language:any): object;
    getTextLabelCSSStyle():object;
    getLabelStartCSSStyle():object;
}

export class TextCSSStyleImpl extends UIComponentCSSStyleImpl implements TextCSSStyle
{
    getWrapperCSSStyle(): object 
    {
        return {
            display: "flex",
            position: "relative",
            flexDirection: "column",
            marginTop: "0px",
        };
    }

    getTextLabelCSSStyle():object
    {
        return{
            height:'20px',
            lineHeight:'20px',
            color:this.getResources().getColor(Colors.color_7),
            textAlign:"left",
            fontSize:this.getResources().getFont(Fonts.h7)
        };
    }
    getLabelStartCSSStyle():object
    {
        return{
            color:this.getResources().getColor(Colors.color_25)
        };
    }
    getTextCSSStyle(isFloatingLabel: boolean, isDisabled:boolean): object 
    {
        console.log("isFloatingLabel: " + isFloatingLabel);
        if(isFloatingLabel)
        {
            return {
                fontSize: this.getResources().getFont(Fonts.h7),
                color: this.getResources().getColor(Colors.color_4),
                height: "40px",
                // bottom: "3px",
                textDecoration: "none",
                fontWeight: 500,
                letterSpacing: 0,
                lineHeight: "40px",
                border:'1px solid '+this.getResources().getColor(Colors.color_8),
                outline: "none",
                paddingLeft: "15px",
                paddingRight: "15px",
                boxShadow:"2px 2px 4px 0 rgba(0,0,0,0.1)",
                borderRadius:'2px',
                backgroundColor:isDisabled? this.getResources().getColor(Colors.color_17): this.getResources().getColor(Colors.color_5),
                boxSizing: "border-box"

            };
        }
        else
        {
            return {
                fontSize: this.getResources().getFont(Fonts.h7),
                backgroundColor:isDisabled? this.getResources().getColor(Colors.color_17):this.getResources().getColor(Colors.color_5),
                color: this.getResources().getColor(Colors.color_4),
                height: "40px",
                // bottom: "3px",
                boxSizing: "border-box",
                textDecoration: "none",
                fontWeight: 500,
                letterSpacing: 0,
                boxShadow:"2px 2px 4px 0 rgba(0,0,0,0.1)",
                borderRadius:'2px',
                lineHeight: "40px",
                border:'1px solid'+this.getResources().getColor(Colors.color_8),
                outline: "none",
                paddingLeft: "15px",
                paddingRight: "15px",
            };
        }
    }

    getErrorCSSStyle(): object {
        return {
            fontSize: this.getResources().getFont(Fonts.h7),
            color: this.getResources().getColor(Colors.color_4),
            height: "40px",
            // bottom: "3px",
            textDecoration: "none",
            fontWeight: 500,
            letterSpacing: 0,
            lineHeight: "40px",
            border:'1px solid '+this.getResources().getColor(Colors.color_8),
            outline: "none",
            paddingLeft: "15px",
            paddingRight: "15px",
            boxShadow:"2px 2px 4px 0 rgba(0,0,0,0.1)",
            borderRadius:'2px',
            backgroundColor: this.getResources().getColor(Colors.color_5),
            boxSizing: "border-box",
            // borderLeft: "2px solid " + this.getResources().getColor(Colors.color_12),
        };
    }

    getErrorTextDivCSSStyle(): object 
    {
        return {
           display: "flex"
        };
    }

    getErrorTextCSSStyle(language:any): object {
        return {
            color: this.getResources().getColor(Colors.color_12),
            fontSize: this.getResources().getFont(Fonts.h5),
            margin:'5px 0px 0px auto'
        };
    } 
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/text/textcss.tsx